export const MODULE_PATH = "dealer";

export const DEALER_HOME = `/s/${MODULE_PATH}/home`;

export const DEALER_LIST = `/s/${MODULE_PATH}/list`;

export const DEALER_DETAIL = `/s/${MODULE_PATH}/detail`;

export const DEALER_BILLING = `/s/${MODULE_PATH}/billing`;
export const DEALER_BILLING_PERIOD = `/s/${MODULE_PATH}/billing/period`;
export const DEALER_BILLING_OWNERS = `/s/${MODULE_PATH}/billing/owners`;
export const DEALER_BILLING_OWNER = `/s/${MODULE_PATH}/billing/owner`;
export const DEALER_BILLING_VEHICLE_YEAR = `/s/${MODULE_PATH}/billing/vehicle/year`;
export const DEALER_BILLING_VEHICLE_MONTH = `/s/${MODULE_PATH}/billing/vehicle/month`;
export const DEALER_BILLING_VEHICLE_DAY = `/s/${MODULE_PATH}/billing/vehicle/day`;
export const DEALER_BILLING_ACCOUNTING = `/s/${MODULE_PATH}/billing/accounting`;
export const DEALER_PAYMENTS = `/s/${MODULE_PATH}/billing/payments`;
export const DEALER_PAYMENTS_PENDING = `${DEALER_PAYMENTS}/pending`;
export const DEALER_PAYMENTS_FINISHED = `${DEALER_PAYMENTS}/finished`;
export const DEALER_PAYMENTS_ALL = `${DEALER_PAYMENTS}/all`;

export const SUBSCRIPTIONS = `/s/${MODULE_PATH}/subscriptions`;
export const SUBSCRIPTION_FORM = `/s/${MODULE_PATH}/subscriptions/form`;
export const SUBSCRIPTION_DETAIL = `/s/${MODULE_PATH}/subscriptions/detail`;

export const MODELS = `/s/${MODULE_PATH}/models`;
export const MODEL_FORM = `/s/${MODULE_PATH}/models/form`;
export const MODELS_FORM_VEHICLE_TYPES = `/s/${MODULE_PATH}/models/form/types`;
export const MODEL_DETAIL = `/s/${MODULE_PATH}/models/detail`;

export const DEVICES_LIST = `/s/${MODULE_PATH}/devices`;
export const DEVICES_FORM = `/s/${MODULE_PATH}/devices/device/form`;
export const DEVICE_DETAIL = `/s/${MODULE_PATH}/devices/detail`;

export const VEHICLES = `/s/${MODULE_PATH}/vehicles`;
export const VEHICLE_FORM = `/s/${MODULE_PATH}/vehicles/form`;
export const DEALER_VEHICLE_DETAIL = `/s/${MODULE_PATH}/vehicles/detail`;
export const VEHICLE_FORM_TYPES = `/s/${MODULE_PATH}/vehicles/form/types`;

export const CUSTOMERS = `/s/${MODULE_PATH}/customers`;
export const CUSTOMERS_FORM = `/s/${MODULE_PATH}/customers/form`;
// It's imported for a component in the kernel
export const CUSTOMERS_OWNERS = `/s/${MODULE_PATH}/customers/owner`;
